import React from 'react';
import { Link } from 'react-router-dom';
import ProjectItem from '../../../../components/ProjectItem/ProjectItem';
import ProjectItem1 from '../../../../components/ProjectItem/ProjectItem1';

const ProjectsArea = () => {
   return (
      <>
         <div className="tp-prjects-area pt-20 pb-120">
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="tp-prjects-tab-menu mb-60">
                        <ul className="nav justify-content-center" id="myTab" role="tablist">
                           <li className="nav-item" role="presentation">
                              <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">All</button>
                           </li>
                          {/*  <li className="nav-item" role="presentation">
                              <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">North</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">East</button>
                           </li>*/}
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab1" data-bs-toggle="tab" data-bs-target="#contact1" type="button" role="tab" aria-controls="contact1" aria-selected="false">South</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab2" data-bs-toggle="tab" data-bs-target="#contact2" type="button" role="tab" aria-controls="contact2" aria-selected="false">West</button>
                           </li>                           
                        </ul>
                     </div>
                  </div>
               </div>
               <div className="row pb-50">
                  <div className="col-12">
                     <div className="tp-prjects-tab-content">
                        <div className="tab-content" id="myTabContent">
                           <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                              <div className="row">                                 

                                 <ProjectItem1 project_img_num="/west/Mr & Mrs Singh.png" project_subtitle="Mr & Mrs. Singh"
                                    project_title="Shree Ganesh Services" linkk="https://youtu.be/M8vFGgiFmh0" vIds="M8vFGgiFmh0"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/west/Bharat Vora.png" project_subtitle="Mr. Bharat Vora"
                                    project_title="Pawan Machineries Pvt Ltd" linkk="https://youtu.be/CI_H9neRJ2g" vIds="v=CI_H9neRJ2g"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/west/Rajesh Singh.png" project_subtitle="Mr.Rajesh Singh"
                                    project_title="Hari Om Centre" linkk="" vIds=""></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Pavitra.png" project_subtitle="Mrs. Pavitra YS"
                                    project_title="Vindhya E-Infomedia Pvt Ltd" linkk="https://www.youtube.com/watch?v=tqfBRIyh7AY" vIds="tqfBRIyh7AY"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Krishnamurthy.png" project_subtitle="Mr. Krishnamurthy Gattappa"
                                    project_title="Krish FashionsBrands Pvt Ltd" linkk="https://www.youtube.com/watch?v=HowA79MYFyg" vIds="HowA79MYFyg"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Shyam.png" project_subtitle="Mr. shyam Shankala"
                                    project_title="Balaji Mithai Bandar" linkk="https://www.youtube.com/watch?v=5JTwdPI6nF8" vIds="5JTwdPI6nF8"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Rajnikanth.png" project_subtitle="Mr. Rajaanikanth Reddy"
                                    project_title="Vijayalaksmi Electricals" linkk="https://www.youtube.com/watch?v=n7VuHpK5vEA" vIds="n7VuHpK5vEA"></ProjectItem1>


                              </div>
                           </div>

                           <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div className="row">
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                              <div className="row">
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact1" role="tabpanel" aria-labelledby="contact-tab1">
                              <div className="row">

                                 <ProjectItem1 project_img_num="/south/Pavitra.png" project_subtitle="Mrs. Pavitra YS"
                                    project_title="Vindhya E-Infomedia Pvt Ltd" linkk="https://www.youtube.com/watch?v=tqfBRIyh7AY" vIds="tqfBRIyh7AY"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Krishnamurthy.png" project_subtitle="Mr. Krishnamurthy Gattappa"
                                    project_title="Krish FashionsBrands Pvt Ltd" linkk="https://www.youtube.com/watch?v=HowA79MYFyg" vIds="HowA79MYFyg"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Shyam.png" project_subtitle="Mr. shyam Shankala"
                                    project_title="Balaji Mithai Bandar"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/south/Rajnikanth.png" project_subtitle="Mr. Rajaanikanth Reddy"
                                    project_title="Vijayalaksmi Electricals" linkk="https://www.youtube.com/watch?v=n7VuHpK5vEA" vIds="n7VuHpK5vEA"></ProjectItem1>

                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact2" role="tabpanel" aria-labelledby="contact-tab2">
                              <div className="row">

                                 <ProjectItem1 project_img_num="/west/Mr & Mrs Singh.png" project_subtitle="Mr & Mrs. Singh"
                                    project_title="Shree Ganesh Services" linkk="https://youtu.be/M8vFGgiFmh0" vIds="M8vFGgiFmh0"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/west/Bharat Vora.png" project_subtitle="Mr. Bharat Vora"
                                    project_title="Pawan Machineries Pvt Ltd" linkk="https://www.youtube.com/watch?v=CI_H9neRJ2g" vIds="v=CI_H9neRJ2g"></ProjectItem1>

                                 <ProjectItem1 project_img_num="/west/Rajesh Singh.png" project_subtitle="Mr.Rajesh Singh"
                                    project_title="Hari Om Centre" linkk="" vIds=""></ProjectItem1>

                              </div>
                           </div>                           

                        </div>
                     </div>
                  </div>
               </div>
               
               {/* <div className="row">
                  <div className="col-12">
                     <div className="tp-projects-btn d-flex justify-content-center">
                        <Link to="/projectsDetails" className="theme-btn text-white">
                           <i className="flaticon-enter"></i> Explore More</Link>
                     </div>
                  </div>
               </div> */}

            </div>
         </div>
      </>
   );
};

export default ProjectsArea;